module.exports = __webpack_public_path__ + "static/media/gru.96ef26ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DynamicContent/About/peopleCompany/gru.png
// module id = 748
// module chunks = 0